import * as React from "react";
import LayoutGrid from "@tunnel-components/layouts/layout/index";
import BreadCrumb from "@tunnel-components/@sharded/widgets/breadcrumb/component";
import Scrollbars from "@tunnel-components/@sharded/@widgets/scrollbars";
import * as Lodash from "lodash";
import * as Paths from "@tunnel-enums/index";
import ConfigSystem from "@tunnel-components/@sharded/@widgets/system-section/component";
import * as i18next from "i18next"; // traduction
// import * as Enums from '@tunnel-enums/index';
//  import * as Utils from '@Cyclope-Utils/index';

/**
 * Le template de systems configuration
 * @function Component
 * @param { any } props
 * @returns { JSX.Element }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (props: any): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */

  const {
    bauChecked,
    swChecked,
    slowroadChecked,
    quickroadChecked,
    onSubmit,
    parkingChecked,
    disabled,
    mileageStart,
    name,
    type,
    length,
    parking,
    quickroad,
    sectionsettings,
    mileageEnd,
    slowroad,
    slowroadMileageStart,
    swMileageStart,
    swMileageEnd,
    sw,
    parkingMileageStart,
    bau,
    bauMileageStart,
    bauMileageEnd,
    onChange,
    parkingMileageEnd,
    slowroadMileageEnd,
    quickroadMileageStart,
    quickroadMileageEnd,
  } = props;

  // const authorization = true;
  // desturation

  const siteLoading: boolean =
    !Lodash.isUndefined(props.sectionsettings) &&
    !Lodash.isEmpty(props.sectionsettings);
  /**
   * @description : retourne un objet ( utilisateur )
   * @const
   * @name User
   * @type { any  }
   */
  // const User : any = Utils.createdUserRoles();
  /**
   * @description : retourne un boolean
   * @const
   * @name authorization
   * @type { boolean  }
   */
  // const authorization : boolean = Utils.simpleAuthorizationIsAllowed(User,[Enums.AuthorizationRightsEnums.SYSTEMUPDATEDTUBES])

  return (
    <LayoutGrid>
      {siteLoading && (
        <section className="tunnel-site animated fadeIn">
          <BreadCrumb
            iconSupervision={true}
            links1={Paths.PathsNamesEnums.SYSTEMSHOME}
            title={i18next.t("supervision")}
            breadText1={i18next.t("systeme")}
            breadText2={props.name}
          />
          <div className="contentAllSiteWithoutOnglet">
            <section className="columnsWithoutOnglet">
              <section className="content-wrapper">
                <section className="settingsScroll with-2-columns">
                  <Scrollbars height="100%" width="100%">
                    {/** Template.systemSectionTubeForm({...props}) */}
                    <ConfigSystem
                      bauchecked={bauChecked}
                      swchecked={swChecked}
                      slowroadchecked={slowroadChecked}
                      quickroadchecked={quickroadChecked}
                      onSubmit={onSubmit}
                      parkingchecked={parkingChecked}
                      disabled={disabled}
                      mileagestart={mileageStart}
                      name={name}
                      type={type}
                      length={length}
                      parking={parking}
                      quickroad={quickroad}
                      sectionsettings={sectionsettings}
                      mileageend={mileageEnd}
                      slowroad={slowroad}
                      slowroadmileagestart={slowroadMileageStart}
                      swmileagestart={swMileageStart}
                      swmileageend={swMileageEnd}
                      sw={sw}
                      parkingmileagestart={parkingMileageStart}
                      bau={bau}
                      baumileagestart={bauMileageStart}
                      baumileageend={bauMileageEnd}
                      onChange={onChange}
                      parkingmileageend={parkingMileageEnd}
                      slowroadmileageend={slowroadMileageEnd}
                      quickroadmileagestart={quickroadMileageStart}
                      quickroadmileageend={quickroadMileageEnd}
                      sectionsavezoneactioncreator=""
                    />
                  </Scrollbars>
                </section>
              </section>
            </section>
          </div>
        </section>
      )}
    </LayoutGrid>
  );
};

/** Valeurs par défaut des props */
Component.defaultProps = {};

/** @export HOC pure */
export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@pages/supervision/systems/config/component.tsx